import { useMutation } from '@tanstack/react-query';
import { POST, POST_LOGOUT } from '../../../services';

export const useLogoutEmployee = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_LOGOUT(), payload);
      return response;
    },
  });

  return {
    mutate,
    isPending,
  };
};
